import { Component, Input, EventEmitter, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ClaimService } from 'src/app/services/claim.service';
import { ALL_SPECIAL_CHARACTERS } from 'src/app/shared/regex-patterns';
import { countries, carriers, productCategory, limitedCarriers, gvmntEntities, States } from '../../../../../config/metadata-config';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ClaimDispute } from 'src/app/shared/models/claim-dispute';
import { IDocument, IDocumentDisplay } from 'src/app/shared/models/claim.interface';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomSuccessComponent } from '../../toaster-component/custom-success/custom-success.component';
import { CustomErrorComponent } from '../../toaster-component/custom-error/custom-error.component';
import { ALLOWED_DOC_TYPES } from 'src/config/app-config';

@Component({
  selector: 'upsc-more-info',
  templateUrl: './more-info.component.html',
  styleUrls: ['./more-info.component.scss']
})
export class MoreInfoComponent {

  form: UntypedFormGroup;
  @Input() claimNumber = '';
  @Output() submittedInfoMore = new EventEmitter<boolean>(false);

  questions = [
    { key: 'delivered', label: 'Was the package marked as "delivered" in the tracking system?' },
    { key: 'correctAddress', label: 'Was the delivery address correct on the shipping label?' },
    { key: 'deliveryNotification', label: 'Did you receive any notification that the package was out for delivery?' },
    { key: 'someoneHome', label: 'Was someone home during the estimated delivery window?' },
    { key: 'deliveryNotice', label: 'Did you receive any delivery attempt notices or tags from UPS with instructions on what is needed to receive your package?' },
    { key: 'cameraNoDelivery', label: ' Is there camera footage during the time of delivery that shows a package was not delivered?' },
    { key: 'cameraTaken', label: ' Is there camera footage from the time of delivery showing the package being taken?' },
    { key: 'deliveryPhoto', label: 'Did UPS have a delivery photo on file for this tracking number?' },
    { key: 'photoMatch', label: 'If you did have a delivery photo on file, does it correspond to the delivery address?' },
    { key: 'followUp', label: 'Did you receive any follow-up communication from the carrier after the delivery scan?' },
    { key: 'rerouted', label: 'Did the retailer confirm shipment from their end?' },
    { key: 'delayClaim', label: 'Was this claim filed due to a delayed delivery?' }
  ];
  // claimNumber: string = "";
  msg: string = "";
  successmsg: boolean;
  showerror: boolean;
  hidestate: boolean = true;
  //hidezip: boolean = true;

  constructor(private fb: UntypedFormBuilder,
    private claimService: ClaimService,
    private snackBar: MatSnackBar,
    private translateService: TranslateService) {
    this.form = this.fb.group({
      reason: ['', [Validators.required, Validators.maxLength(1000)]],
      receiver: this.fb.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        email: ['', Validators.compose([Validators.required, Validators.email])],
        phone: ['', Validators.required],
        country: ['', Validators.required],
        address: ['', Validators.required],
        city: ['', Validators.required],
        state: ['',],
        zip: ['',],
      })
    });

    this.questions.forEach(q => {
      this.form.addControl(q.key, this.fb.control(null, Validators.required));
    });

    // let userDetails = JSON.parse(sessionStorage.getItem('userDetails'));
    // this.claimNumber = userDetails.claimNumber;
  }


  ngOnInit() {
    this.getMetaData();
  }

  onFileChange(event: any) {
    const files = event.target.files;
  }

  claimdispute: ClaimDispute = new ClaimDispute();
  submitted = false;
  moreInfoSubmitted = false;

  submit() {
    this.submitted = true;
    if (this.form.invalid || this.missingRequiredDocs) {
      this.form.markAllAsTouched();
      return;
    }
    this.claimDispute();
  }

  claimDispute() {//CRE claim Auto closer and disputes

    let selectedState = '';
    let stateSelect = this.stateList.find(x => x.id === this.form.value.receiver.state);
    if (stateSelect) {
      selectedState = stateSelect.state;
    }

    this.claimdispute = new ClaimDispute();
    this.claimdispute.claimNumber = this.claimNumber;
    this.claimdispute.question1 = this.form.value.delivered;
    this.claimdispute.question2 = this.form.value.correctAddress;
    this.claimdispute.question3 = this.form.value.deliveryNotification;
    this.claimdispute.question4 = this.form.value.someoneHome;
    this.claimdispute.question5 = this.form.value.deliveryNotice;
    this.claimdispute.question6 = this.form.value.cameraNoDelivery;
    this.claimdispute.question7 = this.form.value.cameraTaken;
    this.claimdispute.question8 = this.form.value.deliveryPhoto;
    this.claimdispute.question9 = this.form.value.photoMatch;
    this.claimdispute.question10 = this.form.value.followUp;
    this.claimdispute.question11 = this.form.value.rerouted;
    this.claimdispute.question12 = this.form.value.delayClaim;
    this.claimdispute.detailedFeedBack = this.form.value.reason;
    this.claimdispute.receiverFirstName = this.form.value.receiver.firstName;
    this.claimdispute.receiverLastName = this.form.value.receiver.lastName;
    this.claimdispute.receiverStreetAddress = this.form.value.receiver.lastName;
    this.claimdispute.receiverCity = this.form.value.receiver.city;
    this.claimdispute.receiverState = selectedState;
    this.claimdispute.receiverPostal = this.form.value.receiver.zip;
    this.claimdispute.receiverCountry = this.form.value.receiver.country;
    this.claimdispute.receiverTelephone = this.form.value.receiver.phone;
    this.claimdispute.receiverEmail = this.form.value.receiver.email;

    this.claimService.getClaimDispute(this.claimdispute).subscribe(
      data => {
        if (data) {
          if (data.status == '500') {
            this.showerror = true;
            this.msg = "Something went wrong, please try again after some time."
          } else if ((data.status == '200') && (data.userMessage == 'Claim Dispute Received successfully')) {
            this.moreInfoSubmitted = true;
            this.submittedInfoMore.emit(true);
          }
        }
      }, error => { }
    );
  }

  sgDocuments = []; //System-generated documents
  uuDocuments = []; //User-uploaded documents
  showFileProgress = false;
  fileTooBig = false;
  fileNameError = false;
  fileTypeError = false;
  systemError = false;
  listOfFiles = new Array();
  missingRequiredDocs: boolean = true;
  errorList = [];
  docRequest: IDocument = {};

  //Metadata / Data Lists
  countryList = [];
  newStateList = [];
  newCountryList = [];
  stateList: any[] = States; //We never pull list of states from metadata API, only comes from config file
  currencyList = {};


  clearDocumentErrors() {
    this.fileTooBig = false;
    this.fileNameError = false;
    this.fileTypeError = false;
    this.systemError = false;
  }



  //First method that is called when documents are attempting to be uploaded.
  //Basically the upload document controller
  //Directs the file to be checked if it can be uploaded, and then attempts upload.
  uploadDocument(files: FileList, bucket: string, event?): void {

    this.errorList = [];
    this.clearDocumentErrors();
    let checkedDocumentsList = this.preliminaryDocumentChecks(files, bucket);
    if (event?.target?.value) {
      event.target.value = null;  //This is required in the scenario the user tries to upload (A), it fails, and then they try to upload (A) again.
    }

    //Now try to upload documents
    // `Hello, my name is ${name} and I am ${age} years old.`;
    if (checkedDocumentsList && checkedDocumentsList.length > 0) {
      for (let i = 0; i < checkedDocumentsList.length; i++) {
        if (checkedDocumentsList[i].shouldBeUploaded) {
          this.generateTokenAndUploadFile(checkedDocumentsList[i].file, bucket);
        } else {
          this.errorList.push({ filename: checkedDocumentsList[i].file.name, error: checkedDocumentsList[i].reasonToNotUpload });
          setTimeout(() => {
            this.snackBar.openFromComponent(CustomErrorComponent, {
              data: { message: `File ${checkedDocumentsList[i].file.name} can not be uploaded: ${checkedDocumentsList[i].reasonToNotUpload}.` },
              duration: 5000,
              horizontalPosition: 'right',
              verticalPosition: 'top'
            });
          });
        }
      }
    }
  }

  generateTokenAndUploadFile(file, bucket) {

    this.claimService.generateUploadToken().subscribe(
      data => {
        this.docRequest = {
          sessionID: data,
          claimNumber: this.claimNumber,
          name: this.formatFileName(file),
          docUID: '001',
          documentType: 'letter_received',
          securityType: 'unrestricted',
          status: 'approved',
          postFnolDoc: "true",
          description: "ONL-Dispute",//bucket,
          mimeType: file.name.endsWith('.msg') ? 'application/vnd.ms-outlook' : file.type
        }

        let formData: FormData = new FormData();
        formData.append('documentUploadRequest', JSON.stringify(this.docRequest));
        formData.append('file', file, this.formatFileName(file));
        // formData.append('policyNumber', this.policy.policyNumber); //Not including this until GW and MS are ready for it

        this.claimService.uploadDocument(formData).subscribe(
          response => {
            if (response.publicID) {
              // Add the file to the appropriate bucket
              if (bucket === "Cre-Documents") {
                this.listOfFiles.push({ file: file, publicID: response.publicID });
              }
              this.updateDocumentStatus();
              setTimeout(() => {
                this.snackBar.openFromComponent(CustomSuccessComponent, {
                  data: { message: 'Your document has been successfully uploaded.' },
                  duration: 5000,
                  horizontalPosition: 'right',
                  verticalPosition: 'top'
                });
              });
            } else {
              this.errorList.push({ filename: file.name, error: 'System error. Please try again' });
            }
          }, error => {
            this.errorList.push({ filename: file.name, error: 'System error. Please try again' });
          }
        );
      }, error => {
        this.errorList.push({ filename: file.name, error: 'System error. Please try again' });
      }
    );
  }


  documentUploadStatus(event: any) {
    if (event.status === 'complete') {
      this.missingRequiredDocs = false;
      this.listOfFiles = event.fileList;
      /*if (this.errorNotification == true && this.whatHappenedFormGroup.valid) {
        this.errorNotification = false;
      }*/
    }
    else {
      this.missingRequiredDocs = true;
    }
  }

  updateDocumentStatus() {
    //others are optional unless the claim reason is damage/1
    if (this.listOfFiles.length > 0) {      
      this.missingRequiredDocs = false;
      sessionStorage.setItem('documentUploadedFiles',
        JSON.stringify({
          invoices: this.listOfFiles.map(i => {
            return {
              publicID: i.publicID,
              file: {
                name: i.file?.name
              }
            }
          })
        })
      );
    }
    else {
      this.missingRequiredDocs = true;
    }
  }

  removeDocument(file: IDocumentDisplay, bucket?: string) {
    this.claimService.removeDocument(file).subscribe(
      data => {
        if (bucket == "Cre-Documents") {
          this.listOfFiles.splice(this.listOfFiles.indexOf(file), 1);
        }
        this.updateDocumentStatus();
      }, error => {
        
      }
    );
  }


  //Input: list of documents
  //Output: list of documents, and whether or not they should be uploaded, and reasoning for that.
  //Checks for things such as filename, filesize, max # of documents per bucket
  preliminaryDocumentChecks(listOfDocs, bucket): any[] {
    let checkedDocumentList = [];    
    for (let i = 0; i < listOfDocs.length; i++) {
      const file = listOfDocs.item(i);
      let object = { file: file, shouldBeUploaded: true, reasonToNotUpload: '' };
      if (file.name.length > 80) {
        object.shouldBeUploaded = false;
        object.reasonToNotUpload = 'The file name exceeds the maximum limit of 70 characters';
      }
      let fileNameParts = file.name.split('.');
      if (fileNameParts.length <= 1 || ALLOWED_DOC_TYPES.indexOf(fileNameParts[fileNameParts.length - 1].toLowerCase()) < 0) {
        object.shouldBeUploaded = false;
        object.reasonToNotUpload = 'The file type is not supported';
      }
      if (file.size >= 10000000) {
        object.shouldBeUploaded = false;
        object.reasonToNotUpload = 'File size exceeds 7MB';
      }
      if (bucket == 'Cre-Documents' && this.listOfFiles.find(x => x.file.name == file.name)) {
        object.shouldBeUploaded = false;
        object.reasonToNotUpload = 'Duplicate files are not allowed';
      }
      checkedDocumentList.push(object)
    }
    return checkedDocumentList;
  }

  formatFileName(file) {
    let extension = file.name.substring(file.name.lastIndexOf('.'));
    let fileNameWithoutExtension = file.name.substring(0, file.name.lastIndexOf('.'));

    try {
      fileNameWithoutExtension = fileNameWithoutExtension.replace(/[\x00-\x08\x0E-\x1F\x7F-\uFFFF]/g, ' ');
      fileNameWithoutExtension = fileNameWithoutExtension.replace(ALL_SPECIAL_CHARACTERS, ' ');
      fileNameWithoutExtension = fileNameWithoutExtension.trim();
    } catch (e) { }

    return `${fileNameWithoutExtension}${extension}`;
  }

  //Sorts an array alphabetically
  //If needing case insensitive, add .toUpperCase()
  //To use: this.someArray.sort(this.compare);
  compare(a, b) {
    if (a.value < b.value) {
      return -1;
    }
    if (a.value > b.value) {
      return 1;
    }
    return 0;
  }

  //Loads all MetaData for claims flow
  getMetaData() {
    this.claimService.getMetaData().subscribe(
      data => {
        try {

          this.newStateList = data.metaData.states;
          this.newCountryList = data.metaData.country;

          this.countryList = Object.entries(countries).map(([key, value]) => ({ key, value })).map(({ key, value }) => { return { key, value: this.translateService.instant(`metadata.country.${key}`) } });
          this.countryList.sort(this.compare);
          this.currencyList = { 'usd': 'USD' }
        } catch (e) {
          //Load local metadata
          this.loadLocalMetaData();
        }
      }, error => {
        // Load local metadata
        this.loadLocalMetaData();
      }
    );
  }

  loadLocalMetaData() {
    this.countryList = Object.entries(countries).map(([key, value]) => ({ key, value })).map(({ key, value }) => { return { key, value: this.translateService.instant(`metadata.country.${key}`) } });//translated countries
    this.countryList.sort(this.compare);
    this.currencyList = { 'usd': 'USD', 'cad': 'CAD', 'eur': 'EUR', 'gbp': 'GBP' }
  }


  //Listen for state changes, if possible, autoselect country when state is chosen
  /*senderAutoCountry() {
    let state = this.startFormGroup.get('sender').get('state').value;
    if (state > 0) {
      if (state == 2 || state == 9 || state == 26 || state == 34 || state == 40 || state == 42 || state == 43 ||
        state == 44 || state == 49 || state == 52 || state == 54 || state == 58 || state == 68) {
        this.startFormGroup.get('sender').get('country').setValue('CA');
        this.startFormGroup.get('sender').get('country').updateValueAndValidity();
      } else {
        this.startFormGroup.get('sender').get('country').setValue('US');
        this.startFormGroup.get('sender').get('country').updateValueAndValidity();
      }
    }
  }*/

  recipientAutoCountry() {
    let state = this.form.get('receiver').get('state').value;
    if (state > 0) {
      if (state == 2 || state == 9 || state == 26 || state == 34 || state == 40 || state == 42 || state == 43 ||
        state == 44 || state == 49 || state == 52 || state == 54 || state == 58 || state == 68) {
        this.form.get('receiver').get('country').setValue('CA');
        this.form.get('receiver').get('country').updateValueAndValidity();
      } else {
        this.form.get('receiver').get('country').setValue('US');
        this.form.get('receiver').get('country').updateValueAndValidity();
      }
    }
  }

  hideState() {
    let country = this.form.get('receiver').get('country').value;
    if (country == 'US') {
      //this.hidezip = false;
      this.hidestate = true;
    } else {
      this.hidestate = false;
    }
  }

  onClick(event: any) {
    if (navigator.appVersion.indexOf('iPhone') > -1) {
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          let overlay = document.getElementById(`cdk-overlay-${i}`);
          if (overlay && overlay.style.top) {
            let offset = Number(overlay.style.top.split('px')[0]) - event.clientY;
            // console.log('offset - ', offset);
            if (offset > 25) {
              overlay.style.top = (event.clientY + 25) + 'px';
            }
            break;
          }
        }
      }, 200);
    }
  }

}
